<template>
    <div class="absolute top-0 left-0 z-10" :style="style">
        <GamificationCostume :costume="costume" :avatar="avatar" v-if="costume" class="w-full h-full" />
        <img :src="avatar" class="rounded-full" alt="profile photo" v-else />
    </div>
</template>

<script>
export default {
    name: 'StudentStationAvatar',
};
</script>
<script setup>
import { computed, reactive, ref, watch } from 'vue';
import anime from 'animejs';
import GamificationCostume from '@/components/pageSpecific/GamificationCostume.vue';
const stationPosition = (i, offSet = 2) => {
    const map = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 3,
        6: 2,
        7: 1,
    };

    return map[(i + offSet) % 8];
};

const props = defineProps({
    avatar: {
        type: String,
        required: true,
    },
    index: {
        type: Number,
        required: true,
    },
    costume: {
        type: Object,
        required: false,
    },
});
const actualIndex = ref(props.index);

const position = reactive({
    x: stationPosition(actualIndex.value, 1) * 100,
    y: actualIndex.value * 100,
});

watch(
    () => props.index,
    (n) => {
        anime({
            targets: position,
            x: stationPosition(n, 1) * 100,
            y: n * 100,
            round: 1,
            easing: 'easeInOutQuad',
            duration: 750,
        });
    },
);

const style = computed(() => {
    return {
        transform: `translate(${position.x}%, ${position.y}%)`,
    };
});
</script>
